import React, {
    useContext,
} from 'react'

import {EmbedContext} from 'components/EmbedContext'
import {EmbedHero} from './components/EmbedHero/EmbedHero'

interface EmbedLoginProps {
    resetEmbed: (clearData?: boolean) => void
}

export const EmbedLogin = (props: EmbedLoginProps) => {
    const embed = useContext(EmbedContext)
    const {resetEmbed} = props

    return (
        <div>
            {embed?.embedState?.error || embed?.embedState?.connectionError ? <EmbedHero resetEmbed={resetEmbed} type='login' /> : null}
        </div>
    )
}
